export class categories {
    cat_id:number|null = null;
    parent_id:number|null = null;
    parent_cat_name:string|null = null;
    title:string|null = null;
    description:string | null = null;
    thumb_image_url:string | null = null;
    seo_id:number | null = null;
    no:number | null = null;
    file:File | null = null;
}

